"use strict";

module.exports = require("./_iterate")("forEach");



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es5-ext/object/for-each.js
// module id = ../../../../es5-ext/object/for-each.js
// module chunks = 4